import {
  Store, UtensilsCrossed, Sparkles, PartyPopper, Wrench, ShoppingBasket,
  Dog, ShoppingCart, Beef, Croissant, ShoppingBag, Utensils, Pizza, Coffee, IceCream,
  Scissors, Shirt, Car, Bed, SprayCan, Hammer, Gem, Flower2, Glasses, PenTool, Fish,
  Cake, GraduationCap, Dumbbell, Cog, CarFront, Tent, Heart,
} from "lucide-react";

export const GROUPS = [
  { id: "negozi", label: "Negozi e vendita", icon: Store, desc: "Vendita al dettaglio, barcode, magazzino, fidelity" },
  { id: "alimentari", label: "Alimentari e vendita al banco", icon: ShoppingBasket, desc: "Vendita a peso, banco, freschi, servizio al tavolo" },
  { id: "ristorazione", label: "Bar e ristorazione", icon: UtensilsCrossed, desc: "Tavoli, sale, comande, preconto, palmari" },
  { id: "servizi", label: "Servizi e appuntamenti", icon: Sparkles, desc: "Agenda, schede clienti, promemoria" },
  { id: "officine", label: "Laboratori, officine e auto", icon: Wrench, desc: "Commesse, schede veicoli, ricambi" },
  { id: "eventi", label: "Eventi e ospitalità", icon: PartyPopper, desc: "Feste, attività temporanee, camere e prenotazioni" },
];

export const ACTIVITIES = {
  negozi: [
    { id: "negozio", label: "Negozio standard", icon: ShoppingBag },
    { id: "negozio_animali", label: "Negozio per Animali", icon: Dog },
    { id: "profumeria", label: "Profumeria", icon: SprayCan },
    { id: "ferramenta", label: "Ferramenta", icon: Hammer },
    { id: "gioielleria", label: "Gioielleria", icon: Gem },
    { id: "fiorista", label: "Fiorista", icon: Flower2 },
    { id: "ottica", label: "Ottica", icon: Glasses },
    { id: "cartoleria", label: "Cartoleria", icon: PenTool },
  ],
  alimentari: [
    { id: "macelleria", label: "Macelleria", icon: Beef },
    { id: "panetteria", label: "Panificio", icon: Croissant },
    { id: "pescheria", label: "Pescheria", icon: Fish },
    { id: "supermercato", label: "Supermercato", icon: ShoppingCart },
    { id: "pasticceria", label: "Pasticceria", icon: Cake },
    { id: "gelateria", label: "Gelateria", icon: IceCream },
  ],
  ristorazione: [
    { id: "bar", label: "Bar / Tavola calda", icon: Coffee },
    { id: "ristorante", label: "Ristorante / Trattoria", icon: Utensils },
    { id: "pizzeria", label: "Pizzeria", icon: Pizza },
  ],
  servizi: [
    { id: "toelettatura", label: "Toelettatura", icon: Dog },
    { id: "parrucchiere", label: "Parrucchiere", icon: Scissors },
    { id: "salone_bellezza", label: "Salone di bellezza", icon: Sparkles },
    { id: "centro_estetico", label: "Centro estetico", icon: Heart },
    { id: "lavanderia", label: "Lavanderia", icon: Shirt },
    { id: "autoscuola", label: "Autoscuola", icon: GraduationCap },
    { id: "palestra", label: "Palestra", icon: Dumbbell },
  ],
  officine: [
    { id: "falegnameria", label: "Falegnameria", icon: Hammer },
    { id: "officina", label: "Officina", icon: Wrench },
    { id: "officina_meccanica", label: "Officina meccanica", icon: Cog },
    { id: "carrozzeria", label: "Carrozzeria", icon: CarFront },
    { id: "autolavaggio", label: "Autolavaggio", icon: Car },
  ],
  eventi: [
    { id: "festa", label: "Feste del paese", icon: PartyPopper },
    { id: "attivita_temporanea", label: "Attività temporanee", icon: Tent },
    { id: "bnb", label: "Alberghiero / B&B", icon: Bed },
  ],
};

// Mappa attività (wizard/contratto) → modalità operative dell'app (POS engine)
export const ACTIVITY_TO_MODES = {
  negozio_animali: ["negozio_animali"],
  toelettatura: ["toelettatura"],
  entrambe: ["negozio_animali", "toelettatura"],
  negozio: ["negozio"], profumeria: ["negozio"], ferramenta: ["negozio"],
  gioielleria: ["negozio"], fiorista: ["negozio"], ottica: ["negozio"], cartoleria: ["negozio"],
  alimentari: ["alimentari"], supermercato: ["alimentari"],
  macelleria: ["macelleria"], pescheria: ["macelleria"],
  panetteria: ["panetteria"], pasticceria: ["panetteria"],
  gelateria: ["gelateria"],
  bar: ["bar"], ristorante: ["ristorante"], pizzeria: ["pizzeria"],
  parrucchiere: ["parrucchiere"], salone_bellezza: ["parrucchiere"], centro_estetico: ["parrucchiere"],
  autoscuola: ["parrucchiere"], palestra: ["parrucchiere"],
  lavanderia: ["lavanderia"],
  falegnameria: ["negozio"], officina: ["negozio"], officina_meccanica: ["negozio"], carrozzeria: ["negozio"],
  autolavaggio: ["autolavaggio"],
  festa: ["festa"], attivita_temporanea: ["festa"],
  bnb: ["bnb"],
  alloggio_dedicato: ["alloggio_dedicato"],
};

export const LODGING_MODE_IDS = ["bnb", "alloggio_dedicato"];

export const isLodgingOnly = (modes) => {
  const list = (Array.isArray(modes) ? modes : []).filter(Boolean);
  return list.length > 0 && list.every((m) => LODGING_MODE_IDS.includes(m));
};

export const ACTIVITY_LABELS = Object.values(ACTIVITIES).flat().reduce(
  (acc, a) => ({ ...acc, [a.id]: a.label }),
  { entrambe: "Negozio Animali + Toelettatura", alloggio_dedicato: "Alberghiero dedicato" }
);
